import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * Small blue dot
 */
@Component({
  selector: 'mb-live-indicator',
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./live-indicator.component.scss'],
})
export class LiveIndicatorComponent {}
